module.exports = __webpack_public_path__ + "33607d3efbab6bd596cb33e1d0d0fa31.fbx";